<template>
  <div class="home _width">
    <!-- header_fxed -->
    <Header></Header>

    <div class="_width conter_works">

      <!-- 页头 -->
      <div class="header_tag _width">
        <div class="wrap">
          <div class="href_tag _height">
            当前位置 &gt;
            <a href="https://v.jingjiribao.cn/">
              首页
            </a>
            &gt;优秀作品
          </div>
        </div>
      </div>
      <!-- 页头 end-->

      <!-- banner -->
      <section class="pc-banner Cooldog_container _width">
        <div class="swiper-container _width anmition_show">
          <el-carousel :interval="40000"
                       type="card"
                       height="586px">
            <el-carousel-item v-for="(item,index) in right_list"
                              :key="index">

              <a :href="`https://v.jingjiribao.cn/works/${item.groupId}/${item.id}.html`"
                 class="_width">
                <p class="cover_title _width">{{ item.name }}</p>
                <img :src="item.thumb"
                     alt="">

                <span class="desc_cover"
                      :title="item.description"
                      v-if="item.description">{{ item.description }}</span>
              </a>
              <div class="layer-mask"></div>

            </el-carousel-item>
          </el-carousel>
        </div>
      </section>
      <!-- banner end-->

      <!-- list -->
      <div class="list _width">
        <div class="wrap">
          <!-- list_left -->
          <div class=list_left>
            <Loading :loading_bool="loading_bool"></Loading>

            <ul id="list_left_ul"
                v-if="!loading_bool && workspages.total !==0">
              <li class="_width fl anmition_show"
                  v-for="(items,indexs) in left_list.records"
                  :key="indexs">
                <a :href="`https://v.jingjiribao.cn/works/${items.groupId}/${items.id}.html`"
                   class="list_left_cover _width fl">
                  <img :src="items.thumb"
                       :alt="items.name">
                </a>

                <a :href="`https://v.jingjiribao.cn/works/${items.groupId}/${items.id}.html`"
                   class="list_left_title _width fl">
                  {{items.name}}
                </a>
                <!--<a href="javascript:; "
                   class="list_left_title_chlid _width fl">经济日报“大美中国•小康印记”</a> -->

                <p class="common _width fl"
                   v-if="items.author">({{items.author}}&nbsp; 摄)</p>

                <div class="user_data fl _width">
                  <!-- <a href="javascript:;"
                     class="header_img _fl">
                    <img :src="items.coverImg">
                  </a> -->
                  <a href="javascript:;"
                     class="name _fl">{{items.description}}</a>
                </div>
              </li>

            </ul>

            <ul id="list_left_ul"
                v-if="!loading_bool && workspages.total ==0">
              <div class="null_data">
                <img src="@/assets/image/common/null_data.png"
                     alt="">
                <p>暂无内容...</p>
              </div>
            </ul>

            <div class="page">
              <!--翻页-->
              <div class="_width page_data card_body mt_15">
                <el-pagination background
                               layout="prev, pager, next"
                               :hide-on-single-page="true"
                               :current-page="workspages.current"
                               @current-change="handleCurrentChange"
                               :page-size="workspages.size"
                               :total="workspages.total">
                </el-pagination>
              </div>
            </div>
          </div>
          <!-- list_left end -->

          <!-- list_right -->
          <div class=list_right>
            <ul id="list_riught_list">

              <li class="_width fl anmition_show"
                  v-for="(items2,indexs) in right_list"
                  :key="indexs">
                <a :href="`https://v.jingjiribao.cn/works/${items2.groupId}/${items2.id}.html`"
                   class="list_right_cover _width">
                  <img :src="items2.thumb"
                       :alt="items2.name"></a>
                <a :href="`https://v.jingjiribao.cn/works/${items2.groupId}/${items2.id}.html`"
                   class="list_right_title _width"> {{items2.name}} </a>
                <p class="_width list_right_name"
                   :title="items2.name"
                   v-if="items2.author"> ({{items2.author}}&nbsp; 摄 )</p>
              </li>

            </ul>
          </div>
          <!-- list_right end -->
        </div>
      </div>
      <!-- list end-->
    </div>

    <!-- footer -->
    <Footer></Footer>
    <!-- footer end-->
  </div>
</template>

<script>

import Loading from '@/components/loading/loading.vue'
import Header from '@/components/common/header.vue'
import Footer from '@/components/common/footer.vue'
import { outStandWork, outStandWorkList } from '@/utils/api/good_works.js'
export default {
  data () {
    return {

      workspages: {
        current: 1,
        size: 10,
        total: 0,

      },
      loading_bool: true,//加载loading

      left_list: [],//左侧list
      right_list: [],//右侧  banner
      // 分页

    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper;
    }
  },
  watch: {},
  created () {
    // list
    let params = {
      current: this.workspages.current,
      size: this.workspages.size,
    }
    this.works_list(params);//列表

    this.right_list_data();//右侧  最热
  },
  mounted () {

  },

  methods: {


    // 左侧列表
    works_list (params) {
      outStandWork(params).then((res) => {
        this.loading_bool = true;
        let data = res.data.data;
        this.left_list = data
        this.workspages.total = data.total;
        this.workspages.current = data.current
        this.workspages.size = data.size
        this.loading_bool = false;

      })
    },


    right_list_data (params) {
      outStandWorkList(params).then((res) => {
        let data = res.data.data;
        this.right_list = data
        console.log(data);

      })
    },

    //作品分页
    handleCurrentChange (val) {
      let params = {
        current: val,
        size: this.workspages.size,
      }
      this.loading_bool = true;
      window.scrollTo(0, 760);
      this.loading = true;
      this.works_list(params)


    },


  },

  components: {
    Loading, Header, Footer
  },
}
</script>

<style scoped>
@import "../../assets/css/good_works/list.css";
</style>



// WEBPACK FOOTER //
// src/views/good_works/works_list.vue